import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { submitLead } from "../../../leadService";
import LayerFour from "../../../assets/images/layers/Layer_4.png";
import Image from "react-bootstrap/Image";
import { Row, Col } from "react-bootstrap";

const EbookModal = ({
  show,
  onHide,
  ebookTitle = "Ebook Title",
  ebookPdfFile = "/Salesforce and Comsense.pdf",
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    mobile: "",
  });

  const businessEmailRegex =
    /@(gmail\.com|yahoo\.com|outlook\.com|hotmail\.com|aol\.com|icloud\.com|protonmail\.com|zoho\.com|mail\.com|gmx\.com)$/i;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // ✅ Validation
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Business Email is required";
    } else if (businessEmailRegex.test(formData.email)) {
      newErrors.email = "Please use business email";
    }

    if (!formData.company.trim()) {
      newErrors.company = "Company Name is required";
    }

    if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10-digit number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");
    setErrors({});

    if (!validate()) {
      setLoading(false);
      setResponseMessage("Please correct the errors.");
      return;
    }


    try {
      const response = await submitLead("ebook", { ...formData, title: ebookTitle, pdf: ebookPdfFile });

      if (response.success) {
        setIsSubmitted(true);
        setResponseMessage("Thanks! Check your email for download link.");

      } else {
        setResponseMessage(response.message);
      }
    } catch (err) {
      setResponseMessage("Error submitting form.");
    }

    setLoading(false);
  };

  return (
    <>
      <style>{`
        .popup-header.modal-header {
          border-bottom: 0;
        }
        .popup-header .btn-close {
          position: absolute;
          right: 20px;
        }
      `}</style>
      <Modal
        show={show}
        onHide={onHide}
        centered
        className="modal-xl"
        style={{ paddingLeft: "0px" }}
      >
        <Modal.Body className="bg-E2F1FE position-relative box-shadow-one rounded-4 p-23 pt-2 p-sm-23 z-0">
          <Modal.Header className="popup-header" closeButton></Modal.Header>
          <Image
            src={LayerFour}
            className="position-absolute bottom-0 start-0 w-40"
            style={{ zIndex: "-1" }}
          />
          <Row className="align-items-center">
            {!isSubmitted && (
              <Col md={5} className="text-center mb-3 mb-md-0">
                <div className="text-left">
                  <h2 className="section-heading fw-700 fs-2">{ebookTitle}</h2>
                  <span
                    style={{
                      background: "#e30016",
                      width: "35%",
                      height: "6px",
                      display: "block",
                    }}
                  ></span>
                </div>
              </Col>
            )}
            <Col lg={isSubmitted ? 12 : 7}>
              {!isSubmitted ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="pb-3 mt-3 mt-lg-0">
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Full Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder=""
                          value={formData.name}
                          onChange={handleChange}
                          isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Business Email <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder=""
                          value={formData.email}
                          onChange={handleChange}
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Company Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="company"
                          placeholder=""
                          value={formData.company}
                          onChange={handleChange}
                          isInvalid={!!errors.company}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.company}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                          type="tel"
                          name="mobile"
                          placeholder="Enter 10-digit phone number"
                          value={formData.mobile}
                          onChange={handleChange}
                          isInvalid={!!errors.mobile}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.mobile}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {responseMessage && (
                      <p
                        className={isSubmitted ? "text-success" : "text-danger"}
                      >
                        {responseMessage}
                      </p>
                    )}
                    <Col lg={12} className="mt-4">
                      <Button
                        type="submit"
                        className="fw-600 d-block btn btn-danger btn-xl"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <div className="text-center py-5">
                  <h2 className="section-heading text-center fw-700 fs-2 mb-4">
                    <span className="bordered-text">Thank You!</span>
                  </h2>
                  {/* <p>{responseMessage}</p> */}
                  <p className="fs-6 mb-4 fw-700">
                    The PDF ebook has been sent to the email address you
                    provided.
                    <br></br>Please check your inbox (or spam/junk folder) to
                    download it.
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EbookModal;
